import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import type { ShortContactDataProps } from "forms/fields/ContactData/types";
import parseDictionary from "forms/helpers/parseDictionary";
import { predefinedFields } from "types/predefinedFields";
interface UseContactDataProps extends Pick<ShortContactDataProps, "allOf"> {}
export default function useContactData(props) {
  const $ = _c(10);
  const {
    getValues
  } = useFormContext();
  const {
    register,
    unregister
  } = useFormContext();
  const getRegionDictionary = _temp;
  let t0;
  if ($[0] !== getValues || $[1] !== props.allOf) {
    t0 = getRegionDictionary({
      value: getValues(predefinedFields.country),
      allOf: props.allOf
    });
    $[0] = getValues;
    $[1] = props.allOf;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const regionDictionary = t0;
  let t1;
  let t2;
  if ($[3] !== regionDictionary || $[4] !== register || $[5] !== unregister) {
    t1 = () => {
      if (regionDictionary) {
        register(predefinedFields.region);
      } else {
        unregister(predefinedFields.region);
      }
    };
    t2 = [register, unregister, regionDictionary];
    $[3] = regionDictionary;
    $[4] = register;
    $[5] = unregister;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] !== regionDictionary) {
    t3 = {
      regionDictionary
    };
    $[8] = regionDictionary;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(t0) {
  const {
    allOf,
    value
  } = t0;
  if (!value) {
    return null;
  }
  const item = allOf.find(i => {
    const constValue = i.if?.properties?.[predefinedFields.country]?.const;
    return Number(constValue) === Number(value);
  });
  if (item) {
    return parseDictionary({
      enumValues: item.then.properties?.[predefinedFields.region].enum,
      enumNames: item.then.properties?.[predefinedFields.region]["x-enumNames"]
    });
  }
  return null;
}